module.exports = __webpack_public_path__ + "static/media/Toyota Capital Motors.e2e974ef.jpg";